module.exports = __webpack_public_path__ + "static/media/test.17a2f55d.jpg";